import { createApp } from "vue";
import router from "./router";
import App from "./App.vue";
import "./assets/css/app.css";
import "./assets/css/easyDT.css";
import Notifications from "@kyvg/vue3-notification";
import Vue3EasyDataTable from "vue3-easy-data-table";
// import "vue3-easy-data-table/dist/style.css";
import * as ConfirmDialog from "vuejs-confirm-dialog";

import { createPinia } from "pinia";
import VueTheMask from 'vue-the-mask'

import { useAuthStore } from "./stores/auth.store";
const pinia = createPinia();
const app = createApp(App);
const options = {
  color: "#bffaf3",
  failedColor: "#874b4b",
  thickness: "5px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 300,
  },
  autoRevert: true,
  location: "top",
  inverse: false,
};
app
  .use(router)
  .use(pinia)
  .use(VueTheMask)
  .use(Notifications)
  .use(ConfirmDialog)
  .component("EasyDataTable", Vue3EasyDataTable);

const userPermissions = useAuthStore();
app.mixin({
  methods: {
    can: (key) => userPermissions?.user?.permissions.includes(key),
  },
});

// Handle OIDC callback params before mounting
const urlParams = new URLSearchParams(window.location.search);
const oidcCode = urlParams.get("oidc_code");
const oidcError = urlParams.get("oidc_error");
const oidcDetail = urlParams.get("oidc_detail");

if (oidcCode || oidcError) {
  // Clear OIDC params from URL so they don't persist on refresh
  history.replaceState(null, "", window.location.pathname + window.location.hash);
}

app.mount("#app");

if (oidcCode) {
  const authStore = useAuthStore();
  authStore.exchangeSsoCode(oidcCode).then((result) => {
    if (result.success) {
      if (result.role === "sso_pending") {
        router.push("/sso-pending");
      } else {
        authStore.verifyActivationKey({ license_key: "" });
        const homePage = authStore.user?.home_page || "/home";
        router.push(homePage);
      }
    } else {
      authStore.ssoError = result.error || "SSO login failed. Please try again.";
      router.push("/login");
    }
  });
} else if (oidcError) {
  const errorMessages = {
    state_mismatch: "Security validation failed. Please try again.",
    session_expired: "Your login session expired. Please try again.",
    token_exchange_failed: "Failed to communicate with the identity provider. Please try again.",
    no_id_token: "The identity provider did not return the expected data. Please try again.",
    invalid_token: "The identity provider returned an invalid response. Please try again.",
    nonce_mismatch: "Security validation failed. Please try again.",
    account_not_found: "No account found. Please contact your administrator.",
    admin_must_convert: "Your account must be converted to SSO by an administrator before you can sign in this way.",
    account_exists_contact_admin: "An account with this email already exists. Please contact your administrator.",
    missing_params: "Invalid login response. Please try again.",
    provider_unreachable: oidcDetail
      ? `Could not reach the identity provider at ${oidcDetail}. Verify the provider URL is correct and reachable.`
      : "Could not reach the identity provider. Please try again later.",
  };
  const authStore = useAuthStore();
  authStore.ssoError = errorMessages[oidcError] || `SSO login failed: ${oidcError}`;
  router.push("/login");
}
